export const CandidateFeedbackStatusesEnum = {
  PENDING: {
    value: 1,
    label: 'pending'
  },
  COMPLETED: {
    value: 2,
    label: 'completed'
  },
  DELETED: {
    value: 3,
    label: 'deleted'
  }
}